import type { ReactNode } from 'react';
import styles from './ui.module.css';

export interface TabOption<T extends string> {
  id: T;
  label: string;
  icon?: ReactNode;
  testId?: string;
  controls?: string;
}

interface TabsProps<T extends string> {
  label: string;
  value: T;
  options: TabOption<T>[];
  onChange: (value: T) => void;
  className?: string;
}

export function Tabs<T extends string>({
  label,
  value,
  options,
  onChange,
  className,
}: TabsProps<T>) {
  return (
    <div className={`${styles.tabs} ${className ?? ''}`} role="tablist" aria-label={label}>
      {options.map((option) => (
        <button
          type="button"
          className={styles.tab}
          role="tab"
          aria-selected={value === option.id}
          aria-controls={option.controls}
          key={option.id}
          data-testid={option.testId}
          onClick={() => onChange(option.id)}
        >
          {option.icon}
          {option.label}
        </button>
      ))}
    </div>
  );
}
